import LinkArrow from './LinkArrow'

export default LinkArrow
